<style lang="scss">
    .box{
        position: relative;
        padding-bottom:30px;
    }
    .page-title {
        padding: 30px 40px 10px 40px;
        border-bottom:1px #d8d9df solid ;
        h2 {
            font-family: microsoft yahei;
            font-size:24px;
            color:#333333;
            font-weight: normal;

        }
    }
    .box{
        padding:40px 30px;
        .summary{
            margin-bottom:30px;
        }
        table-box{
            .header{
                font-size:14px;
                color:#697d9b;
                background:#d8d9df;
                font-weight:normal;
                text-align: center;
            }

        }


    }
    .yrd-service{
        margin-top:30px;
        text-align: center;
        img{
            width:180px;
        }

    }

</style>

<template>
    <div class="box">
        <div class="page-title clearfix">
            <h2>还款计划</h2>
        </div>
        <div class="box">
            <div class="summary">
                <el-row>
                    <el-col :span="12">
                        <p >
                        借款产品：{{info.showKind }}   |   借款申请：{{info.amount | currency}}元/{{info.period}}期
                        </p>
                    </el-col>
                    <el-col :span="12">
                        <p style="text-align: right;" >
                            申请时间：{{ info.created | formatDate('YYYY.MM.DD')}}   |   状态：{{info.status && flowStatus[info.status]['text']}}
                        </p>
                    </el-col>
                </el-row>

            </div>


            <div class="table-box" v-loading="loading">
                <el-table
                        header-cell-class-name="header"
                        :data="tableData"
                        border
                        style="width: 100%">
                    <el-table-column
                            min-width="90"
                            prop="periodEndDate"
                            label="还款截止日"
                            align="center"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.periodEndDate | formatDate('YYYY-MM-DD')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="planAmt"
                            label="应还金额"
                            align="center"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.planAmt | currency}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="planPrincipal"
                            label="本金">
                        <template slot-scope="scope">
                            {{ scope.row.planPrincipal | currency}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if=" capitalName!='HUAXIA' &&  capitalName!='XINWANG'"
                            align="center"
                            prop="planInterest"
                            label="息费">
                        <template slot-scope="scope">
                            {{ scope.row.planTotalInterest | currency}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            v-if="capitalName=='XINWANG' || capitalName=='HUAXIA'"
                            align="center"
                            prop="planInterest"
                            label="利息">
                        <template slot-scope="scope">
                            {{ scope.row.planInterest | currency}}
                        </template>
                    </el-table-column>


                    <el-table-column
                            v-if=" capitalName!='HUAXIA' &&  capitalName!='XINWANG'"
                            align="center"
                            prop="planGuaranteeManageFee"
                            label="分期服务保障金">
                        <template slot-scope="scope">
                            {{ scope.row.planTotalGuaranteeManageFee | currency}}
                        </template>

                    </el-table-column>
                    <el-table-column
                            v-if=" capitalName=='HUAXIA'"
                            align="center"
                            prop="planGuaranteeManageFee"
                            label="分期保费">
                        <template slot-scope="scope">
                            {{ scope.row.planGuaranteeAmount | currency}}
                        </template>

                    </el-table-column>


                    <el-table-column
                            align="center"
                            prop="planOverdueLateFee"
                            label="逾期费用">
                        <template slot-scope="scope">

                        {{ scope.row.planPayOvedueAmount | currency}}
                        </template>


                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="remark"
                            label="实际已还">
                        <template slot-scope="scope">
                            {{ scope.row.repaidAmt | currency}}
                        </template>

                    </el-table-column>
                    <el-table-column
                            align="center"
                            prop="repaymentPeriodState"
                            label="还款状态"
                            :formatter="formatState"
                    >
                    </el-table-column>
                </el-table>

            </div>

        </div>

        <div v-if="capitalName=='XINWANG' || capitalName=='HUAXIA'" class="yrd-service"><img src="../../assets/images/service.png" alt=""></div>


    </div>
</template>
<script>

	export default {

		data() {
			return {
				loading:false,
				capitalName:"",
				tableData:[],
                info:{},
                dictState:{
					'UNPAY':'未还款',
                    'UN_CLEARD':'未结清',
                    'CLEARED':'已结清'
                }
			}

		},
		computed:{
			productType(){
				return this.$store.state.productType
			},
			flowStatus(){
				return this.$store.state.flowStatus
			},
		},
        methods:{
			formatState(row){
				if(row.isOverdue){
					return '已逾期'
                }
                return this.dictState[row.repaymentPeriodState]
            },
			getDetail(){
				this.loading=true
				this.$axios({
					method: 'get',
					url: '/borrows/'+this.$route.params.applyId+'/repayment',
				}).then( (res) =>{
					console.log(res)
					this.loading=false
                    this.capitalName = res.data.capitalName;
                    this.tableData = res.data.repaymentPlans
				}).catch( (err)=> {
					this.loading=false
					console.warn(err)
				})
			},
			getInfo(){
				this.info = JSON.parse(localStorage.getItem(this.$route.params.applyId))
			}
        },

        mounted(){
            this.getDetail()
            this.getInfo()
        }
	}
</script>